<template>
    <div class="blog-post" :class="theme">
        <a
            class="item-wrapper"
            v-for="item in list"
            :key="item.id"
            :href="item.url"
            rel="noopener noreferrer"
        >
            <img-box
                class="preview-img"
                v-if="!!item.previewPicture"
                :src="item.previewPicture"
                :alt="item.title || 'Image for Blog'"
            />
            <div class="head-content">
                <div class="title">{{ item.title }}</div>
                <div v-if="showDate" class="date">
                    <only-client>{{ $ft.formatDate(+item.publishTime, 'MMMM dd, yyyy hh:mm p') }}</only-client>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: ['list', 'title', 'theme', 'showDate'] // theme  set style
};
</script>

<style lang="scss">
@import '../theme/mixin.scss';
.blog-post {
    .item-wrapper {
        display: flex;
        margin: 20px 0;

        .preview-img {
            flex: none;
            height: 54px;
            width: 54px;
            padding-top: 0;
            margin-right: 12px;
            &.fashion {
                border-radius: 50%;
            }
        }

        .head-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: calc(100% - 54px - 12px);

            .title {
                line-height: 20px;
                font-size: 16px;
                color: #4a4a60;
                font-family: var(--font-medium);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .date {
                margin-top: 6px;
                line-height: 14px;
                font-size: 12px;
                color: #4a4a60;
            }
        }
    }
    &.template2 {
        .item-wrapper {
            .preview-img {
                border-radius: 50%;
            }
            .head-content {
                .title {
                    color: #282828;
                }
                .date {
                    color: #787878;
                }
            }
        }
    }
    &.standard {
        .item-wrapper {
            .preview-img {
                border-radius: 50%;
            }
            .head-content {
                flex-direction: column-reverse;
                .title {
                    color: #515666;
                    font-family: var(--font-normal);
                }
                .date {
                    color: #a0a3af;
                    line-height: 1.83;
                    margin: 0;
                }
            }
        }
    }
    &.broker {
        .item-wrapper {
            &:hover {
                .head-content {
                    .title {
                        color: var(--color-theme);
                        text-decoration: underline;
                    }
                }
            }
            .preview-img {
                width: 97px;
                height: 70px;
                margin-right: 15px;
                background-image: linear-gradient(
                    to top,
                    rgba(60, 60, 76, 0.7),
                    rgba(0, 0, 0, 0)
                );
                border-radius: 5px;
            }
            .head-content {
                justify-content: space-between;
                .title {
                    color: #191919;
                    font-family: var(--font-medium);
                    font-size: 14px;
                    @include webkitBox(2);
                }
                .date {
                    color: #a8a8a8;
                    font: 12px var(--font-medium);
                    line-height: 15px;
                    margin: 0;
                }
            }
        }
    }
}
</style>
